import { ComponentEvents } from 'global/interfaces/component.interface';

export const MyMoleculeFinderSelectStepEvents: ComponentEvents = {
	clicked: 'MoleculeFinderSelectStepClickEvent',
	back: 'MoleculeFinderSelectStepClickEventBack',
	products: 'MoleculeFinderSelectStepClickEventProducts',
	start: 'MoleculeFinderSelectStepClickEventStart',
};

export interface MoleculeFinderSelectStepEvent {
	additionalId: number
}
